import React from "react";
import "./styles/Button.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "ghost";
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = "default",
  loading = false,
  className = "",
  disabled,
  children,
  ...props
}) => {
  const classMap: Record<string, string> = {
    default: "btn-default",
    outline: "btn-outline",
    ghost: "btn-ghost",
  };

  return (
    <button
      className={`btn-base ${classMap[variant]} ${className} ${loading ? "btn-loading" : ""}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="spinner" />}
      {children}
    </button>
  );
};

export { Button };
